import { Link } from "react-router-dom";
import { TrendingUp } from "lucide-react";
import { slugify } from "@/lib/slugify";

const CATEGORIES = [
    "Renda Fixa", "Ações e Dividendos", "Fundos Imobiliários",
    "Orçamento e Organização", "Independência Financeira", "Impostos e Planejamento",
];

const INSTITUTIONAL = [
    { label: "Calculadora do investidor", href: "/calculadora" },
    { label: "Sobre nós", href: "/sobre" },
    { label: "Contato", href: "/contato" },
    { label: "Política de Privacidade", href: "/privacidade" },
    { label: "Área da redação", href: "/admin" },
];

export const Footer = () => (
    <footer data-testid="main-footer" className="border-t border-white/10 bg-ink">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
                <div className="md:col-span-4">
                    <Link to="/" className="flex items-center gap-2.5">
                        <span className="flex items-center justify-center w-8 h-8 bg-gold text-ink">
                            <TrendingUp size={18} strokeWidth={2.5} />
                        </span>
                        <span className="font-serif text-xl tracking-tight">
                            Investidor <span className="text-gold italic">Comum</span>
                        </span>
                    </Link>
                    <p className="mt-5 text-sm text-slate-500 leading-relaxed max-w-sm">
                        Educação financeira independente, em português claro, para quem está começando.
                        Sem promessa de enriquecimento rápido — só método, matemática e paciência.
                    </p>
                </div>

                <div className="md:col-span-2">
                    <span className="text-xs uppercase tracking-[0.25em] text-slate-500 font-medium">Categorias</span>
                    <ul className="mt-5 flex flex-col gap-3">
                        {CATEGORIES.map((c) => (
                            <li key={c}>
                                <Link to={`/categoria/${slugify(c)}`} data-testid={`footer-category-${slugify(c)}`} className="text-sm text-slate-400 hover:text-gold transition-colors">
                                    {c}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-2">
                    <span className="text-xs uppercase tracking-[0.25em] text-slate-500 font-medium">Institucional</span>
                    <ul className="mt-5 flex flex-col gap-3">
                        {INSTITUTIONAL.map((l) => (
                            <li key={l.href}>
                                <Link to={l.href} data-testid={`footer-link-${l.href.replace(/\//g, "") || "home"}`} className="text-sm text-slate-400 hover:text-gold transition-colors">
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <span className="text-xs uppercase tracking-[0.25em] text-slate-500 font-medium">Transparência</span>
                    <p className="mt-5 text-xs text-slate-600 leading-relaxed">
                        Este site é monetizado por publicidade do Google AdSense, links de afiliados e
                        produtos patrocinados — todos sempre identificados. Conteúdo patrocinado passa
                        pelo mesmo filtro editorial do conteúdo independente.
                    </p>
                    <p className="mt-4 text-xs text-slate-600 leading-relaxed">
                        Nada aqui constitui recomendação de investimento. Rentabilidade passada não
                        garante resultados futuros. Consulte um profissional certificado antes de
                        tomar decisões financeiras.
                    </p>
                </div>
            </div>
        </div>

        <div className="border-t border-white/5">
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
                <span className="text-xs text-slate-600">© 2026 Investidor Comum — investidorcomum.com.br</span>
                <span className="text-[10px] uppercase tracking-[0.25em] text-slate-700">Feito com método, não com sorte</span>
            </div>
        </div>
    </footer>
);
